theme.Slideshow = (function() {
    this.$slideshow = null;
    var classes = {
      slideshow: 'slideshow',
      slickActiveMobile: 'slick-active-mobile',
      controlsHover: 'slideshow__controls--hover',
      isPaused: 'is-paused'
    };
  
    var selectors = {
      section: '.shopify-section',
      wrapper: '#SlideshowWrapper-',
      slides: '.slideshow__slide',
      textWrapperMobile: '.slideshow__text-wrap--mobile',
      textContentMobile: '.slideshow__text-content--mobile',
      controls: '.slideshow__controls',
      pauseButton: '.slideshow__pause',
      dots: '.slick-dots',
      arrows: '.slideshow__arrows',
      arrowsMobile: '.slideshow__arrows--mobile',
      arrowLeft: '.slideshow__arrow-left',
      arrowRight: '.slideshow__arrow-right'
    };
  
    function slideshow(el, sectionId) {
      var $slideshow = (this.$slideshow = $(el));
      this.adaptHeight = this.$slideshow.data('adapt-height');
      this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
      this.$section = this.$wrapper.closest(selectors.section);
      this.$controls = this.$wrapper.find(selectors.controls);
      this.$arrows = this.$section.find(selectors.arrows);
      this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
      this.$pause = this.$controls.find(selectors.pauseButton);
      this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
      this.autorotate = this.$slideshow.data('autorotate');
      var autoplaySpeed = this.$slideshow.data('speed');
      var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
  
      this.settings = {
        accessibility: true,
        arrows: false,
        dots: true,
        fade: true,
        draggable: true,
        touchThreshold: 20,
        autoplay: this.autorotate,
        autoplaySpeed: autoplaySpeed,
        lazyLoad: 'ondemand',
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        appendDots: this.$arrows
      };
  
      this.$slideshow.on('beforeChange', beforeChange.bind(this));
      this.$slideshow.on('init', slideshowA11ySetup.bind(this));
  
      // Add class to style mobile dots & show the correct text content for the
      // first slide on mobile when the slideshow initialises
      this.$slideshow.on(
        'init',
        function() {
          this.$mobileDots
            .find('li:first-of-type')
            .addClass(classes.slickActiveMobile);
          this.showMobileText(0);
        }.bind(this)
      );
  
      // Stop the autorotate when you scroll past the mobile controls, resume when
      // they are scrolled back into view
      if (this.autorotate) {
        $(document).scroll(
          $.debounce(
            250,
            function() {
              if (
                this.$arrowsMobile.offset().top +
                  this.$arrowsMobile.outerHeight() <
                window.pageYOffset
              ) {
                $slideshow.slick('slickPause');
              } else if (!this.$pause.hasClass(classes.isPaused)) {
                $slideshow.slick('slickPlay');
              }
            }.bind(this)
          )
        );
      }
  
      if (this.adaptHeight) {
        this.setSlideshowHeight();
        $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
      }
  
      this.$slideshow.slick(this.settings);
  
      // This can't be called when the slick 'init' event fires due to how slick
      // adds a11y features.
      slideshowPostInitA11ySetup.bind(this)();
  
      this.$arrows.find(selectors.arrowLeft).on('click', function() {
        $slideshow.slick('slickPrev');
      });
      this.$arrows.find(selectors.arrowRight).on('click', function() {
        $slideshow.slick('slickNext');
      });
  
      this.$pause.on('click', this.togglePause.bind(this));
    }
  
    function slideshowA11ySetup(event, obj) {
      var $slider = obj.$slider;
      var $list = obj.$list;
      this.$dots = this.$section.find(selectors.dots);
      this.$mobileDots = this.$dots.eq(1);
  
      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');
  
      this.$wrapper.on('keyup', keyboardNavigation.bind(this));
      this.$controls.on('keyup', keyboardNavigation.bind(this));
      this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));
  
      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      this.$wrapper
        .on(
          'focusin',
          function(evt) {
            if (!this.$wrapper.has(evt.target).length) {
              return;
            }
  
            $list.attr('aria-live', 'polite');
            if (this.autorotate) {
              $slider.slick('slickPause');
            }
          }.bind(this)
        )
        .on(
          'focusout',
          function(evt) {
            if (!this.$wrapper.has(evt.target).length) {
              return;
            }
  
            $list.removeAttr('aria-live');
            if (this.autorotate) {
              // Only resume playing if the user hasn't paused using the pause
              // button
              if (!this.$pause.is('.is-paused')) {
                $slider.slick('slickPlay');
              }
            }
          }.bind(this)
        );
  
      // Add arrow key support when focused
      if (this.$dots) {
        this.$dots
          .find('a')
          .each(function() {
            var $dot = $(this);
            $dot.on('click keyup', function(evt) {
              if (
                evt.type === 'keyup' &&
                evt.which !== slate.utils.keyboardKeys.ENTER
              )
                return;
  
              evt.preventDefault();
  
              var slideNumber = $(evt.target).data('slide-number');
  
              $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);
  
              if (evt.type === 'keyup') {
                $slider.focus();
              }
            });
          })
          .eq(0)
          .attr('aria-current', 'true');
      }
  
      this.$controls
        .on('focusin', highlightControls.bind(this))
        .on('focusout', unhighlightControls.bind(this));
    }
  
    function slideshowPostInitA11ySetup() {
      var $slides = this.$slideshow.find(selectors.slides);
  
      $slides.removeAttr('role').removeAttr('aria-labelledby');
      this.$dots
        .removeAttr('role')
        .find('li')
        .removeAttr('role')
        .removeAttr('aria-selected')
        .each(function() {
          var $dot = $(this);
          var ariaControls = $dot.attr('aria-controls');
          $dot
            .removeAttr('aria-controls')
            .find('a')
            .attr('aria-controls', ariaControls);
        });
        //this.$dots.find('button').removeAttr('role');
    }
  
    function beforeChange(event, slick, currentSlide, nextSlide) {
      var $dotLinks = this.$dots.find('a');
      var $mobileDotLinks = this.$mobileDots.find('li');
  
      $dotLinks
        .removeAttr('aria-current')
        .eq(nextSlide)
        .attr('aria-current', 'true');
  
      $mobileDotLinks
        .removeClass(classes.slickActiveMobile)
        .eq(nextSlide)
        .addClass(classes.slickActiveMobile);
      this.showMobileText(nextSlide);
    }
  
    function keyboardNavigation() {
      if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
        this.$slideshow.slick('slickPrev');
      }
      if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
        this.$slideshow.slick('slickNext');
      }
    }
  
    function highlightControls() {
      this.$controls.addClass(classes.controlsHover);
    }
  
    function unhighlightControls() {
      this.$controls.removeClass(classes.controlsHover);
    }
  
    slideshow.prototype.togglePause = function() {
      var slideshowSelector = getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
        if (this.autorotate) {
          $(slideshowSelector).slick('slickPlay');
        }
      } else {
        this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
        if (this.autorotate) {
          $(slideshowSelector).slick('slickPause');
        }
      }
    };
  
    slideshow.prototype.setSlideshowHeight = function() {
      var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
      this.$slideshow.height($(document).width() / minAspectRatio);
    };
  
    slideshow.prototype.showMobileText = function(slideIndex) {
      var $allTextContent = this.$textWrapperMobile.find(
        selectors.textContentMobile
      );
      var currentTextContentSelector =
        selectors.textContentMobile + '-' + slideIndex;
      var $currentTextContent = this.$textWrapperMobile.find(
        currentTextContentSelector
      );
      if (
        !$currentTextContent.length &&
        this.$slideshow.find(selectors.slides).length === 1
      ) {
        this.$textWrapperMobile.hide();
      } else {
        this.$textWrapperMobile.show();
      }
      $allTextContent.hide();
      $currentTextContent.show();
    };
  
    function getSlideshowId($el) {
      return '#Slideshow-' + $el.data('id');
    }
  
    return slideshow;
  })();
  
  theme.Video = (function() {
    var autoplayCheckComplete = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
      ratio: 16 / 9,
      scrollAnimationDuration: 400,
      playerVars: {
        // eslint-disable-next-line camelcase
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        wmode: 'opaque',
        branding: 0,
        autohide: 0,
        rel: 0
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerChange
      }
    };
    var classes = {
      playing: 'video-is-playing',
      paused: 'video-is-paused',
      loading: 'video-is-loading',
      loaded: 'video-is-loaded',
      backgroundVideoWrapper: 'video-background-wrapper',
      videoWithImage: 'video--image_with_play',
      backgroundVideo: 'video--background',
      userPaused: 'is-paused',
      supportsAutoplay: 'autoplay',
      supportsNoAutoplay: 'no-autoplay',
      wrapperMinHeight: 'video-section-wrapper--min-height'
    };
  
    var selectors = {
      section: '.video-section',
      videoWrapper: '.video-section-wrapper',
      playVideoBtn: '.video-control__play',
      closeVideoBtn: '.video-control__close-wrapper',
      pauseVideoBtn: '.video__pause',
      pauseVideoStop: '.video__pause-stop',
      pauseVideoResume: '.video__pause-resume',
      fallbackText: '.icon__fallback-text'
    };
  
    /**
     * Public functions
     */
    function init($video) {
      if (!$video.length) {
        return;
      }
  
      videos[$video.attr('id')] = {
        id: $video.attr('id'),
        videoId: $video.data('id'),
        type: $video.data('type'),
        status:
          $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
        $video: $video,
        $videoWrapper: $video.closest(selectors.videoWrapper),
        $section: $video.closest(selectors.section),
        controls: $video.data('type') === 'background' ? 0 : 1
      };
  
      if (!youtubeLoaded) {
        // This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
  
      playOnClickCheck();
    }
  
    function customPlayVideo(playerId) {
      // Make sure we have carried out the playOnClick check first
      if (!playOnClickChecked && !playOnClick) {
        return;
      }
  
      if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
        privatePlayVideo(playerId);
      }
    }
  
    function pauseVideo(playerId) {
      if (
        videoPlayers[playerId] &&
        typeof videoPlayers[playerId].pauseVideo === 'function'
      ) {
        videoPlayers[playerId].pauseVideo();
      }
    }
  
    function loadVideos() {
      for (var key in videos) {
        if (videos.hasOwnProperty(key)) {
          createPlayer(key);
        }
      }
  
      initEvents();
      youtubeLoaded = true;
    }
  
    function editorLoadVideo(key) {
      if (!youtubeLoaded) {
        return;
      }
      createPlayer(key);
  
      initEvents();
    }
  
    /**
     * Private functions
     */
  
    function privatePlayVideo(id, clicked) {
      var videoData = videos[id];
      var player = videoPlayers[id];
      var $videoWrapper = videoData.$videoWrapper;
  
      if (playOnClick) {
        // playOnClick means we are probably on mobile (no autoplay).
        // setAsPlaying will show the iframe, requiring another click
        // to play the video.
        setAsPlaying(videoData);
      } else if (clicked || autoplayCheckComplete) {
        // Play if autoplay is available or clicked to play
        $videoWrapper.removeClass(classes.loading);
        setAsPlaying(videoData);
        player.playVideo();
        return;
      } else {
        player.playVideo();
      }
    }
  
    function setAutoplaySupport(supported) {
      var supportClass = supported
        ? classes.supportsAutoplay
        : classes.supportsNoAutoplay;
      $(document.documentElement)
        .removeClass(classes.supportsAutoplay)
        .removeClass(classes.supportsNoAutoplay)
        .addClass(supportClass);
  
      if (!supported) {
        playOnClick = true;
      }
  
      autoplayCheckComplete = true;
    }
  
    function playOnClickCheck() {
      // Bail early for a few instances:
      // - small screen
      // - device sniff mobile browser
  
      if (playOnClickChecked) {
        return;
      }
  
      if (isMobile()) {
        playOnClick = true;
      }
  
      if (playOnClick) {
        // No need to also do the autoplay check
        setAutoplaySupport(false);
      }
  
      playOnClickChecked = true;
    }
  
    // The API will call this function when each video player is ready
    function onPlayerReady(evt) {
      evt.target.setPlaybackQuality('hd1080');
      var videoData = getVideoOptions(evt);
      var videoTitle = evt.target.getVideoData().title;
      playOnClickCheck();
  
      // Prevent tabbing through YouTube player controls until visible
      $('#' + videoData.id).attr('tabindex', '-1');
  
      sizeBackgroundVideos();
      setButtonLabels(videoData.$videoWrapper, videoTitle);
  
      // Customize based on options from the video ID
      if (videoData.type === 'background') {
        evt.target.mute();
        privatePlayVideo(videoData.id);
      }
  
      videoData.$videoWrapper.addClass(classes.loaded);
    }
  
    function onPlayerChange(evt) {
      var videoData = getVideoOptions(evt);
      if (
        videoData.status === 'background' &&
        !isMobile() &&
        !autoplayCheckComplete &&
        (evt.data === YT.PlayerState.PLAYING ||
          evt.data === YT.PlayerState.BUFFERING)
      ) {
        setAutoplaySupport(true);
        autoplayCheckComplete = true;
        videoData.$videoWrapper.removeClass(classes.loading);
      }
      switch (evt.data) {
        case YT.PlayerState.ENDED:
          setAsFinished(videoData);
          break;
        case YT.PlayerState.PAUSED:
          // Seeking on a YouTube video also fires a PAUSED state change,
          // checking the state after a delay prevents us pausing the video when
          // the user is seeking instead of pausing
          setTimeout(function() {
            if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
              setAsPaused(videoData);
            }
          }, 200);
          break;
      }
    }
  
    function setAsFinished(videoData) {
      switch (videoData.type) {
        case 'background':
          videoPlayers[videoData.id].seekTo(0);
          break;
        case 'image_with_play':
          closeVideo(videoData.id);
          toggleExpandVideo(videoData.id, false);
          break;
      }
    }
  
    function setAsPlaying(videoData) {
      var $videoWrapper = videoData.$videoWrapper;
      var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
  
      $videoWrapper.removeClass(classes.loading);
  
      if ($pauseButton.hasClass(classes.userPaused)) {
        $pauseButton.removeClass(classes.userPaused);
      }
  
      // Do not change element visibility if it is a background video
      if (videoData.status === 'background') {
        return;
      }
  
      $('#' + videoData.id).attr('tabindex', '0');
  
      if (videoData.type === 'image_with_play') {
        $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
      }
  
      // Update focus to the close button so we stay within the video wrapper,
      // allowing time for the scroll animation
      setTimeout(function() {
        $videoWrapper.find(selectors.closeVideoBtn).focus();
      }, videoOptions.scrollAnimationDuration);
    }
  
    function setAsPaused(videoData) {
      var $videoWrapper = videoData.$videoWrapper;
  
      // YT's events fire after our click event. This status flag ensures
      // we don't interact with a closed or background video.
      if (videoData.type === 'image_with_play') {
        if (videoData.status === 'closed') {
          $videoWrapper.removeClass(classes.paused);
        } else {
          $videoWrapper.addClass(classes.paused);
        }
      }
  
      $videoWrapper.removeClass(classes.playing);
    }
  
    function closeVideo(playerId) {
      var videoData = videos[playerId];
      var $videoWrapper = videoData.$videoWrapper;
      var classesToRemove = [classes.paused, classes.playing].join(' ');
  
      if (isMobile()) {
        $videoWrapper.removeAttr('style');
      }
  
      $('#' + videoData.id).attr('tabindex', '-1');
  
      videoData.status = 'closed';
  
      switch (videoData.type) {
        case 'image_with_play':
          videoPlayers[playerId].stopVideo();
          setAsPaused(videoData); // in case the video is already paused
          break;
        case 'background':
          videoPlayers[playerId].mute();
          setBackgroundVideo(playerId);
          break;
      }
  
      $videoWrapper.removeClass(classesToRemove);
    }
  
    function getVideoOptions(evt) {
      var id = evt.target.getIframe().id;
      return videos[id];
    }
  
    function toggleExpandVideo(playerId, expand) {
      var video = videos[playerId];
      var elementTop = video.$videoWrapper.offset().top;
      var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
      var offset = 0;
      var newHeight = 0;
  
      if (isMobile()) {
        video.$videoWrapper.parent().toggleClass('page-width', !expand);
      }
  
      if (expand) {
        if (isMobile()) {
          newHeight = $(window).width() / videoOptions.ratio;
        } else {
          newHeight = video.$videoWrapper.width() / videoOptions.ratio;
        }
        offset = ($(window).height() - newHeight) / 2;
  
        video.$videoWrapper
          .removeClass(classes.wrapperMinHeight)
          .animate({ height: newHeight }, 600);
  
        // Animate doesn't work in mobile editor, so we don't use it
        if (!(isMobile() && Shopify.designMode)) {
          $('html, body').animate(
            {
              scrollTop: elementTop - offset
            },
            videoOptions.scrollAnimationDuration
          );
        }
      } else {
        if (isMobile()) {
          newHeight = video.$videoWrapper.data('mobile-height');
        } else {
          newHeight = video.$videoWrapper.data('desktop-height');
        }
  
        video.$videoWrapper
          .height(video.$videoWrapper.width() / videoOptions.ratio)
          .animate({ height: newHeight }, 600);
        setTimeout(function() {
          video.$videoWrapper.addClass(classes.wrapperMinHeight);
        }, 600);
        $playButton.focus();
      }
    }
  
    function togglePause(playerId) {
      var $pauseButton = videos[playerId].$videoWrapper.find(
        selectors.pauseVideoBtn
      );
      var paused = $pauseButton.hasClass(classes.userPaused);
      if (paused) {
        $pauseButton.removeClass(classes.userPaused);
        customPlayVideo(playerId);
      } else {
        $pauseButton.addClass(classes.userPaused);
        pauseVideo(playerId);
      }
      $pauseButton.attr('aria-pressed', !paused);
    }
  
    function startVideoOnClick(playerId) {
      var video = videos[playerId];
  
      // add loading class to wrapper
      video.$videoWrapper.addClass(classes.loading);
  
      // Explicity set the video wrapper height (needed for height transition)
      video.$videoWrapper.attr(
        'style',
        'height: ' + video.$videoWrapper.height() + 'px'
      );
  
      video.status = 'open';
  
      switch (video.type) {
        case 'image_with_play':
          privatePlayVideo(playerId, true);
          break;
        case 'background':
          unsetBackgroundVideo(playerId, video);
          videoPlayers[playerId].unMute();
          privatePlayVideo(playerId, true);
          break;
      }
  
      toggleExpandVideo(playerId, true);
  
      // esc to close video player
      $(document).on('keydown.videoPlayer', function(evt) {
        var playerId = $(document.activeElement).data('controls');
        if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
          return;
        }
  
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
    }
  
    function sizeBackgroundVideos() {
      $('.' + classes.backgroundVideo).each(function(index, el) {
        sizeBackgroundVideo($(el));
      });
    }
  
    function sizeBackgroundVideo($videoPlayer) {
      if (!youtubeLoaded) {
        return;
      }
  
      if (isMobile()) {
        $videoPlayer.removeAttr('style');
      } else {
        var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
        var videoWidth = $videoWrapper.width();
        var playerWidth = $videoPlayer.width();
        var desktopHeight = $videoWrapper.data('desktop-height');
  
        // when screen aspect ratio differs from video, video must center and underlay one dimension
        if (videoWidth / videoOptions.ratio < desktopHeight) {
          playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
          $videoPlayer
            .width(playerWidth)
            .height(desktopHeight)
            .css({
              left: (videoWidth - playerWidth) / 2,
              top: 0
            }); // player width is greater, offset left; reset top
        } else {
          // new video width < window width (gap to right)
          desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
          $videoPlayer
            .width(videoWidth)
            .height(desktopHeight)
            .css({
              left: 0,
              top: (desktopHeight - desktopHeight) / 2
            }); // player height is greater, offset top; reset left
        }
  
        $videoPlayer.prepareTransition();
        $videoWrapper.addClass(classes.loaded);
      }
    }
  
    function unsetBackgroundVideo(playerId) {
      // Switch the background video to a chrome-only player once played
      $('#' + playerId)
        .removeClass(classes.backgroundVideo)
        .addClass(classes.videoWithImage);
  
      setTimeout(function() {
        $('#' + playerId).removeAttr('style');
      }, 600);
  
      videos[playerId].$videoWrapper
        .removeClass(classes.backgroundVideoWrapper)
        .addClass(classes.playing);
  
      videos[playerId].status = 'open';
    }
  
    function setBackgroundVideo(playerId) {
      $('#' + playerId)
        .removeClass(classes.videoWithImage)
        .addClass(classes.backgroundVideo);
  
      videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);
  
      videos[playerId].status = 'background';
      sizeBackgroundVideo($('#' + playerId));
    }
  
    function isMobile() {
      return $(window).width() < 750 || window.mobileCheck();
    }
  
    function initEvents() {
      $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data('controls');
  
        startVideoOnClick(playerId);
      });
  
      $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data('controls');
  
        $(evt.currentTarget).blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
  
      $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data('controls');
        togglePause(playerId);
      });
  
      // Listen to resize to keep a background-size:cover-like layout
      $(window).on(
        'resize.videoPlayer',
        $.debounce(200, function() {
          if (!youtubeLoaded) return;
          var key;
          var fullscreen = window.innerHeight === screen.height;
  
          sizeBackgroundVideos();
  
          if (isMobile()) {
            for (key in videos) {
              if (videos.hasOwnProperty(key)) {
                if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                  if (!fullscreen) {
                    pauseVideo(key);
                    setAsPaused(videos[key]);
                  }
                }
                videos[key].$videoWrapper.height(
                  $(document).width() / videoOptions.ratio
                );
              }
            }
            setAutoplaySupport(false);
          } else {
            setAutoplaySupport(true);
            for (key in videos) {
              if (
                videos[key].$videoWrapper.find('.' + classes.videoWithImage)
                  .length
              ) {
                continue;
              }
              videoPlayers[key].playVideo();
              setAsPlaying(videos[key]);
            }
          }
        })
      );
  
      $(window).on(
        'scroll.videoPlayer',
        $.debounce(50, function() {
          if (!youtubeLoaded) return;
  
          for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
              var $videoWrapper = videos[key].$videoWrapper;
  
              // Close the video if more than 75% of it is scrolled out of view
              if (
                $videoWrapper.hasClass(classes.playing) &&
                ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                  $(window).scrollTop() ||
                  $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                    $(window).scrollTop() + $(window).height())
              ) {
                closeVideo(key);
                toggleExpandVideo(key, false);
              }
            }
          }
        })
      );
    }
  
    function createPlayer(key) {
      var args = $.extend({}, videoOptions, videos[key]);
      args.playerVars.controls = args.controls;
      videoPlayers[key] = new YT.Player(key, args);
    }
  
    function removeEvents() {
      $(document).off('.videoPlayer');
      $(window).off('.videoPlayer');
    }
  
    function setButtonLabels($videoWrapper, title) {
      var $playButtons = $videoWrapper.find(selectors.playVideoBtn);
      var $closeButton = $videoWrapper.find(selectors.closeVideoBtn);
      var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
      var $closeButtonText = $closeButton.find(selectors.fallbackText);
      var $pauseButtonStopText = $pauseButton
        .find(selectors.pauseVideoStop)
        .find(selectors.fallbackText);
      var $pauseButtonResumeText = $pauseButton
        .find(selectors.pauseVideoResume)
        .find(selectors.fallbackText);
  
      // Insert the video title retrieved from YouTube into the instructional text
      // for each button
      $playButtons.each(function() {
        var $playButton = $(this);
        var $playButtonText = $playButton.find(selectors.fallbackText);
  
        $playButtonText.text(
          $playButtonText.text().replace('[video_title]', title)
        );
      });
      $closeButtonText.text(
        $closeButtonText.text().replace('[video_title]', title)
      );
      $pauseButtonStopText.text(
        $pauseButtonStopText.text().replace('[video_title]', title)
      );
      $pauseButtonResumeText.text(
        $pauseButtonResumeText.text().replace('[video_title]', title)
      );
    }
  
    return {
      init: init,
      editorLoadVideo: editorLoadVideo,
      loadVideos: loadVideos,
      playVideo: customPlayVideo,
      pauseVideo: pauseVideo,
      removeEvents: removeEvents
    };
  })();

theme.Hero = (function() {
    var classes = {
      indexSectionFlush: 'index-section--flush'
    };
  
    var selectors = {
      heroFixedWidthContent: '.hero-fixed-width__content',
      heroFixedWidthImage: '.hero-fixed-width__image'
    };
  
    function hero(el, sectionId) {
      this.$hero = $(el);
      this.layout = this.$hero.data('layout');
      var $parentSection = $('#shopify-section-' + sectionId);
      var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
      var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);
  
      if (this.layout !== 'fixed_width') {
        return;
      }
  
      $parentSection.removeClass(classes.indexSectionFlush);
      heroFixedHeight();
      $(window).resize(
        $.debounce(50, function() {
          heroFixedHeight();
        })
      );
  
      function heroFixedHeight() {
        var contentHeight = $heroContent.height() + 50;
        var imageHeight = $heroImage.height();
  
        if (contentHeight > imageHeight) {
          $heroImage.css('min-height', contentHeight);
        }
      }
    }
  
    return hero;
  })();

theme.Quotes = (function() {
    var config = {
      mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      slideCount: 0
    };
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Quotes(container) {
      var $container = (this.$container = $(container));
      var sectionId = $container.attr('data-section-id');
      var wrapper = (this.wrapper = '.quotes-wrapper');
      var slider = (this.slider = '#Quotes-' + sectionId);
      var $slider = $(slider, wrapper);
  
      var sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      config.slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (config.slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = config.slideCount;
        defaults.slidesToScroll = config.slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      enquire.register(config.mediaQuerySmall, {
        match: function() {
          initSlider($slider, mobileOptions);
        }
      });
  
      enquire.register(config.mediaQueryMediumUp, {
        match: function() {
          initSlider($slider, defaults);
        }
      });
  
      function initSlider(sliderObj, args) {
        if (sliderActive) {
          sliderObj.slick('unslick');
          sliderActive = false;
        }
  
        sliderObj.slick(args);
        sliderActive = true;
      }
    }
  
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
      onUnload: function() {
        enquire.unregister(config.mediaQuerySmall);
        enquire.unregister(config.mediaQueryMediumUp);
  
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $(
          '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
        );
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Quotes;
  })();
  
theme.slideshows = {};
  
theme.SlideshowSection = (function() {
    function SlideshowSection(container) {
      var $container = (this.$container = $(container));
      var sectionId = $container.attr('data-section-id');
      var slideshow = (this.slideshow = '#Slideshow-' + sectionId);
  
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
    }
  
    return SlideshowSection;
  })();
  
theme.SlideshowSection.prototype = _.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function() {
        delete theme.slideshows[this.slideshow];
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
        var adaptHeight = $slideshow.data('adapt-height');
  
        if (adaptHeight) {
          theme.slideshows[this.slideshow].setSlideshowHeight();
        }
  
        // Ignore the cloned version
        var $slide = $(
          '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
        );
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause auto-rotate
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        // Resume auto-rotate
        $(this.slideshow).slick('slickPlay');
      }
    }
  );
  
  theme.slideshows = {};
  
  theme.VideoSection = (function() {
    function VideoSection(container) {
      var $container = (this.$container = $(container));
  
      $('.video', $container).each(function() {
        var $el = $(this);
        theme.Video.init($el);
        theme.Video.editorLoadVideo($el.attr('id'));
      });
    }
  
    return VideoSection;
  })();
  
  theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
    onUnload: function() {
      theme.Video.removeEvents();
    }
  });
  
  theme.heros = {};
  
  theme.HeroSection = (function() {
    function HeroSection(container) {
      var $container = (this.$container = $(container));
      var sectionId = $container.attr('data-section-id');
      var hero = '#Hero-' + sectionId;
      theme.heros[hero] = new theme.Hero(hero, sectionId);
    }
  
    return HeroSection;
  })();

  // Youtube API callback
  // eslint-disable-next-line no-unused-vars
  function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos();
  }  

  $(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('map', theme.Maps);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('quotes', theme.Quotes);
    sections.register('hero-section', theme.HeroSection);

    $('.controls-slide .slick-dots').remove();
    $('.arrows_dots').find('li:first-child').addClass('slick-active');
  });

  // CUstom JS

  if (window.matchMedia("(max-width: 1023px) and (min-width: 769px)").matches) {
    $('.highlights-banners').slick({
      slidesToShow: 4,
      arrows: false,
      infinite: false
    });
  }

  if (window.matchMedia("(max-width: 768px) and (min-width: 651px)").matches) {
    $('.highlights-banners').slick({
      slidesToShow: 3,
      arrows: false,
      infinite: false
    });
  }

  if (window.matchMedia("(max-width: 650px)").matches) {
    $('.highlights-banners').slick({
      slidesToShow: 2,
      arrows: false,
      infinite: false
    });
  }

  $('.highlights-banners').find('.slick-track').attr('role', 'list');
  $('.highlights-banners').find('.slick-track').find('.highlights-banners-block').attr('role', 'listitem');

  $('.main-image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    prevArrow:"<button type='button' class='slick-prev pull-left' aria-label='Previous slide'>Previous<img width='11' height='19' alt='Previous' src='https://cdn.shopify.com/s/files/1/1082/2542/files/Left_Arrow.svg?v=1616837000' /></button>",
    nextArrow:"<button type='button' class='slick-next pull-right' aria-label='Next slide'>Next<img width='11' height='19' alt='Next' src='https://cdn.shopify.com/s/files/1/1082/2542/files/Right_Arrow.svg?v=1616837118' /></button>"
  });

  $('.main-image-slider').find('.slick-track').attr('role', 'list');
  $('.main-image-slider').find('.slick-track').find('.product-single__media-wrapper').attr('role', 'listitem');

  $('.controls-slide button').on('click', function(e){
    e.stopPropagation();
    e.preventDefault();
  });